import Joi from 'joi';

import {
  tenantContactCompanyNameOptional,
  tenantContactCreateIdRule,
  tenantContactWriteFields,
} from '../../../../shared/modules/contacts/validators/schemas/tenant-contact-write-fields.schema';

/**
 * Schema for contact validation when creating a new location contact.
 */
export const createLocationContactSchema = () =>
  Joi.object({
    ...tenantContactCreateIdRule(),
    ...tenantContactCompanyNameOptional(),
    ...tenantContactWriteFields(),
  }).unknown();
